import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    // base: process.env.VUE_APP_BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [
        {
            // =============================================================================
            // Checkout Routes
            // =============================================================================
            path: '/',
            name: 'wizard',
            component: () => import('./views/Wizard.vue'),
        },
        {
            // =============================================================================
            // Checkout Routes
            // =============================================================================
            path: '/billet',
            name: 'billet',
            component: () => import('./views/Billet.vue')
        },
        {
            // =============================================================================
            // Checkout Routes
            // =============================================================================
            path: '/payment',
            name: 'payment',
            component: () => import('./views/Payment.vue')
        }
    ]
})

export default router
